import { DEFAULT_IMAGE_SRC } from "@constants";
import clsx from "clsx";
import React from "react";
import { ButtonGroup, Card, Placeholder, Stack } from "react-bootstrap";
import styles from "./style/CourseCard.module.css";

const CourseCardPlaceholder = ({ variant }) => {
  return (
    <Card
      className={clsx(
        styles.courseCard,
        "p-2",
        variant === "horizontal" && styles.courseCardHorizontal
      )}
    >
      <div className={clsx(styles.cardImg, "position-relative")}>
        <div className={styles.cardImgWrapper}>
          <Card.Img src={DEFAULT_IMAGE_SRC} />
        </div>
      </div>
      <Card.Body className={styles.cardBody}>
        <div>
          <Placeholder size="xs" xs={4} />
          <Placeholder as={Card.Title} animation="glow">
            <Placeholder xs={12} />
            <Placeholder xs={10} />
          </Placeholder>
        </div>
        <div>
          <Placeholder animation="glow">
            <Stack className="justify-content-between" gap={1}>
              <Placeholder xs={8} />
              <Placeholder xs={7} />
            </Stack>
          </Placeholder>
          <ButtonGroup size="sm" className="w-100 mt-2">
            <Placeholder.Button variant="primary" />
            <Placeholder.Button variant="outline-primary" />
          </ButtonGroup>
        </div>
      </Card.Body>
    </Card>
  );
};

/* required: display name */
CourseCardPlaceholder.displayName = "CourseCardPlaceholder";

/* required: props types */
CourseCardPlaceholder.propTypes = {};

/* required: default props */
CourseCardPlaceholder.defaultProps = {};

export { CourseCardPlaceholder };
